import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { SidebarService } from '../sidebar/sidebar.service';
import { AdminAuthService } from '../../core/auth/admin-auth.service';
// import { AuthService } from 'src/app/services/auth.service';
// import { Store } from '@ngrx/store';
// import { getCurrentUser } from 'src/app/reducers/auth/auth.selectors';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  private readonly breakpointObserver = inject(BreakpointObserver);
  currentUser;
  readonly isCompact$ = this.breakpointObserver
    .observe([Breakpoints.Handset, '(max-width: 991px)'])
    .pipe(
      map((result) => result.matches),
      shareReplay({ bufferSize: 1, refCount: true }),
    );

  constructor(
    private sidebarService: SidebarService,
    private authService: AdminAuthService,
    private router: Router,
    // private store: Store
  ) {
    this.currentUser = this.authService.getCurrentUser();
  }

  ngOnInit() {
    // this.store.select(getCurrentUser).subscribe((user) => {
    //   this.currentUser = user;
    // });
  }

  // isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
  //   map((result) => result.matches),
  //   shareReplay()
  // );

  toggleSidebar() {
    this.sidebarService.toggle();
  }
  // logout() {
  //   this.authService.logout();
  // }

  goToMyProfile() {
    this.router.navigate(['/profile']);
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}
